import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { GlobalStylesProvider } from "@zapier/design-system";
import { UpgradeModalProvider } from "@zapier/upsells/esm/contexts";
import { UpgradeModalLayout } from "./UpgradeModalLayout";
import { useUpgradeModal } from "./useUpgradeModal";
import { useQuery as defaultUseQuery, useMutation as defaultUseMutation, } from "@apollo/react-hooks";
export const UpgradeModal = ({ appName, onClose, onUpgradeFinish = () => {
}, shouldAutoUpgrade = true, upgradeReason, wasTriggeredByZapToggle = false, useQuery = defaultUseQuery, useMutation = defaultUseMutation, }) => {
    const upgradeModalData = useUpgradeModal({
        appName,
        shouldAutoUpgrade,
        upgradeReason,
        useMutation,
        useQuery,
    });
    return (_jsx(GlobalStylesProvider, { isPlatform: true, isRebrand: true, children: _jsx(UpgradeModalProvider, { upgradeModalData: upgradeModalData, children: _jsx(UpgradeModalLayout, { appName: appName, onClose: onClose, onUpgradeFinish: onUpgradeFinish, shouldAutoUpgrade: shouldAutoUpgrade, upgradeReason: upgradeReason, useMutation: useMutation, useQuery: useQuery, wasTriggeredByZapToggle: wasTriggeredByZapToggle }) }) }));
};

// @zapier/upsells@8.0.1 (466b4077f)
